import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const acceptInviteUrl = `${process.env.REACT_APP_BACKEND_URL}/api/admin/invites/accept`;

export default function AcceptInvitePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = new URLSearchParams(location.hash.replace("#", "")).get("token");

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!token) {
      setError("This invitation is incomplete. Ask an admin for a new link.");
      return;
    }
    if (password !== confirmation) {
      setError("Your passwords need to match.");
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        acceptInviteUrl,
        { token, name, password },
        { withCredentials: true },
      );
      navigate("/dashboard", { replace: true, state: { user: response.data.user } });
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "This invitation is no longer valid.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="recovery-page" data-testid="accept-invite-page">
      <section className="recovery-panel">
        <p className="eyebrow">You’re invited</p>
        <h1 data-testid="accept-invite-heading">Join Cardfolio</h1>
        <p className="recovery-description" data-testid="accept-invite-description">
          Set up your account and step into the workday with your team.
        </p>
        <form className="recovery-form" onSubmit={submit} data-testid="accept-invite-form">
          <label className="auth-field" data-testid="accept-invite-name-field">
            <span>Your name</span>
            <input value={name} onChange={(event) => setName(event.target.value)} type="text" required data-testid="accept-invite-name-input" />
          </label>
          <label className="auth-field" data-testid="accept-invite-password-field">
            <span>Create a password</span>
            <input value={password} onChange={(event) => setPassword(event.target.value)} type="password" minLength={8} required data-testid="accept-invite-password-input" />
          </label>
          <label className="auth-field" data-testid="accept-invite-confirmation-field">
            <span>Confirm password</span>
            <input value={confirmation} onChange={(event) => setConfirmation(event.target.value)} type="password" minLength={8} required data-testid="accept-invite-confirmation-input" />
          </label>
          {error && <p className="auth-error" data-testid="accept-invite-error">{error}</p>}
          <button className="email-submit-button" type="submit" disabled={isSubmitting} data-testid="accept-invite-submit-button">
            {isSubmitting ? "Creating…" : "Create your account"}
          </button>
        </form>
      </section>
    </main>
  );
}